<style scoped lang="scss">

</style>

<template>
    <vk-modal stack :show.sync="isOpen">
        <vk-modal-close v-if="source === 'property-wizard'" @click="isOpen = false"></vk-modal-close>
        <vk-modal-title slot="header">Select/Add User</vk-modal-title>
        <div class="wrap uk-grid uk-form">
            <div class="uk-width-1-1 uk-margin-bottom">
                <p class="uk-margin-bottom-remove"><small>Input User Email</small></p>
                <autocomplete
                        :placeholder="'User Email'"
                        ref="autocomplete"
                        class="form-autocomplete"
                        :search="search"
                        :get-result-value="getResultValue"
                        :debounce-time="200"
                        @submit="selectUser"
                >
                </autocomplete>
                <p v-if="showErrorMsg" class="uk-text-danger">Email Address is invalid.</p>
            </div>
        </div>
        <div slot="footer" class="uk-text-right uk-grid-1-1">
            <vk-button type="default" @click="isOpen = false">Cancel</vk-button>
            <vk-button type="primary" @click="onConfirm">Add</vk-button>
        </div>
    </vk-modal>
</template>

<script>
    import Autocomplete from '@trevoreyre/autocomplete-vue';
    export default {
        name: "UserSelect",
        components: {
            Autocomplete
        },
        props: {
            source: {
                type: String,
                default: 'property-wizard'
            }
        },
        data() {
            return {
                userEmail: '',
                isOpen: false,
                showErrorMsg: false,
            }
        },
        created() {
        },
        computed: {
        },
        methods: {
            openModal() {
                this.showErrorMsg = false
                this.$refs.autocomplete.value = ''
                this.isOpen = true
            },

            closeModal() {
                this.isOpen = false
            },

            async search(query) {
                this.showErrorMsg = false
                this.userEmail = query
                if(query.length < 3) return [];
                // Search People
                let url = '/api/projects/search-users';

                let r = await axios.get(url+'?q='+query);
                return r.data;
            },

            getResultValue(user) {
                return `${user.email} (${user.first_name} ${user.last_name})`;
            },

            selectUser(user) {
                this.$emit('on-select', user)
                this.closeModal()
            },

            onConfirm() {
                if (this.validateEmail(this.userEmail))
                {
                    this.$emit('on-add', this.userEmail)
                    this.closeModal()
                } else {
                    this.showErrorMsg = true
                }
            },

            validateEmail(email) {
                const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return re.test(String(email).toLowerCase());
            }
        }
    }
</script>
